import * as React from "react";
import {
  cards,
  cardsItem,
  brandTeaserContainer,
  title,
  description,
} from "./BrandTeasers.module.scss";

export const BrandTeaserContainer: React.FC<any> = (props) => {
  return <div className={brandTeaserContainer}>{props.children}</div>;
};

export const Title: React.FC<any> = (props) => {
  return (
    <div className={title} id={props.id}>
      {props.children}
    </div>
  );
};
export const Description: React.FC<any> = (props) => {
  return (
    <div
      className={description}
      dangerouslySetInnerHTML={{ __html: props.field_description }}
    ></div>
  );
};

export const BrandCards: React.FC<any> = (props) => {
  return <ul className={cards}>{props.children}</ul>;
};

export const BrandCardsItem: React.FC<any> = (props) => {
  return <li className={cardsItem}>{props.children}</li>;
};
